module.exports = __webpack_public_path__ + "img/key_text.1dcb04e7.svg";